
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class StatusPanel extends Vue {
  @Prop({ required: true }) readonly isSending!: boolean;

  @Prop({ required: true }) readonly isEmergencyTimeSet!: boolean;

  @Prop({ default: null }) readonly emergencyReleaseTime!: string | null;

  @Prop({ default: null }) readonly emergencyPredictionTime!: string | null;

  @Prop({ default: null }) readonly nextSendTime!: string | null;

  get emergencyTimeLabel(): string {
    if (this.isEmergencyTimeSet && this.emergencyReleaseTime) {
      return `設定済 ${this.formatDateTime(this.emergencyReleaseTime)}`;
    }
    if (this.emergencyPredictionTime) {
      return `未設定（予測：${this.formatDateTime(this.emergencyPredictionTime)}）`;
    }
    return '未設定';
  }

  formatDateTime(yyyymmddhhmm: string): string {
    if (!yyyymmddhhmm || yyyymmddhhmm.length < 12) return yyyymmddhhmm;
    const month = yyyymmddhhmm.slice(4, 6);
    const day = yyyymmddhhmm.slice(6, 8);
    const hour = yyyymmddhhmm.slice(8, 10);
    const minute = yyyymmddhhmm.slice(10, 12);
    return `${month}月${day}日 ${hour}:${minute}`;
  }
}
